import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { IGoodsToReceiveTransactionRecordDto } from "../../../dtos/transactions/IGoodsToReceiveTransactionRecordDto";

interface IProps {
  items: IGoodsToReceiveTransactionRecordDto[];
}

export const GoodsToReceiveTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="recorderType" dataType={"number"} caption="Recorder Type" />
          <Column width={150} dataField="businessTransactionType" dataType={"number"} caption="Business Transaction Type" />
          <Column width={150} dataField="receiveDocumentId" dataType={"string"} caption="Receive Document" />
          <Column width={150} dataField="productId" dataType={"string"} caption="Product" />
          <Column width={150} dataField="warehouseId" dataType={"string"} caption="Warehouse" />
          <Column width={150} dataField="vendorId" dataType={"string"} caption="Vendor" />
          <Column width={150} dataField="toVendorInvoiceBasedAtOrder" dataType={"number"} caption="To Vendor Invoice Based At Order" />
          <Column width={150} dataField="toReceiveBasedAtOrder" dataType={"number"} caption="To Receive Based At Order" />
          <Column width={150} dataField="toReceiveBasedAtVendorInvoice" dataType={"number"} caption="To Receive Based At Vendor Invoice" />

          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
